/**
 * Mirrors para-node `src/constants/internal/internal-permissions.constants.ts` (`InternalPermissions`)
 * member for member. No endpoint lists internal permissions, so the role editor's catalogue is
 * this copy. When the backend adds one, add it here AND to a group in
 * `internalPermissionGroups.ts` — the spec beside that file fails until both are done.
 */
export enum InternalPermission {
  InternalUsersView = 'internal_users_view',
  InternalUsersManage = 'internal_users_manage',
  InternalRolesView = 'internal_roles_view',
  InternalRolesManage = 'internal_roles_manage',
  InternalAuditLogsView = 'internal_audit_logs_view',

  PartnersView = 'partners_view',
  PartnersCreate = 'partners_create',
  PartnersLoginAs = 'partners_login_as',
  PartnerSettingsView = 'partner_settings_view',
  PartnerSettingsManage = 'partner_settings_manage',
  PartnerProductsView = 'partner_products_view',
  PartnerProductsManage = 'partner_products_manage',
  PartnerOnboardMasterContractor = 'partner_onboard_master_contractor',
  PartnersDelete = 'partners_delete',
  PartnerBillingView = 'partner_billing_view',
  PartnerBillingManage = 'partner_billing_manage',

  OrganizationsView = 'organizations_view',
  OrganizationsManage = 'organizations_manage',

  CustomerUsersView = 'customer_users_view',
  CustomerUsersManage = 'customer_users_manage',
  CustomerUserAccessUpdate = 'customer_user_access_update',
  CustomerInvitesView = 'customer_invites_view',
  CustomerInvitesManage = 'customer_invites_manage',
  CustomerRolesView = 'customer_roles_view',
  CustomerRolesManage = 'customer_roles_manage',
  CustomerRolesDelete = 'customer_roles_delete',

  MarketsView = 'markets_view',
  MarketsManage = 'markets_manage',

  CollectDataTemplatesView = 'collect_data_templates_view',
  CollectDataTemplatesManage = 'collect_data_templates_manage',
  DocusignTemplatesView = 'docusign_templates_view',
  DocusignTemplatesManage = 'docusign_templates_manage',

  ContractorsView = 'contractors_view',
  ContractorsManage = 'contractors_manage',
  ContractorTemplateChange = 'contractor_template_change',
  ContractorOnboardingStatusManage = 'contractor_onboarding_status_manage',
  ContractorStepsManage = 'contractor_steps_manage',
  ContractorDocumentsManage = 'contractor_documents_manage',
  ContractorDataDelete = 'contractor_data_delete',

  DocumentReviewView = 'document_review_view',
  DocumentReviewApprove = 'document_review_approve',
  DocumentReviewRecollect = 'document_review_recollect',

  McDocumentReviewView = 'mc_document_review_view',
  McDocumentReviewApprove = 'mc_document_review_approve',
  McDocumentReviewReject = 'mc_document_review_reject',

  InsuranceProductsView = 'insurance_products_view',
  InsuranceProductsManage = 'insurance_products_manage',
  InsurancePoliciesView = 'insurance_policies_view',
  InsurancePoliciesManage = 'insurance_policies_manage',
  InsuranceContractsUpload = 'insurance_contracts_upload',

  AiDocumentReviewConfigsView = 'ai_document_review_configs_view',
  AiDocumentReviewConfigsManage = 'ai_document_review_configs_manage',

  LmsTrainingsView = 'lms_trainings_view',
  LmsTrainingsManage = 'lms_trainings_manage',

  PayoutSettingsView = 'payout_settings_view',
  PayoutSettingsManage = 'payout_settings_manage',

  PaymentsReviewView = 'payments_review_view',
  PaymentsReviewDecide = 'payments_review_decide',
  PaymentsReviewBulkApprove = 'payments_review_bulk_approve',
  TransactionsReviewView = 'transactions_review_view',
  TransactionsAssignInvoice = 'transactions_assign_invoice',
  TransactionsAuthorize = 'transactions_authorize',
  RefundsView = 'refunds_view',
  RefundsInitiate = 'refunds_initiate',
  RefundsExecute = 'refunds_execute',
  ReconciliationRun = 'reconciliation_run',
  WalletsView = 'wallets_view',
  FeeWithdrawalsView = 'fee_withdrawals_view',
  UsBankTransactionsView = 'us_bank_transactions_view',
  BankOnboardingView = 'bank_onboarding_view',
  BankOnboardingManage = 'bank_onboarding_manage',
  UsBankKillswitchManage = 'us_bank_killswitch_manage',
  UsBankCapturedEventsReplay = 'us_bank_captured_events_replay',

  InvoicesView = 'invoices_view',
  InvoicesManage = 'invoices_manage',
  HistoricalInvoicesUpload = 'historical_invoices_upload',

  YardstikView = 'yardstik_view',
  YardstikManage = 'yardstik_manage',
  OatfiView = 'oatfi_view',
  OatfiManage = 'oatfi_manage',
  PlaidLinkGenerate = 'plaid_link_generate',

  OauthClientsView = 'oauth_clients_view',
  OauthClientsManage = 'oauth_clients_manage',
  OauthTokensRevoke = 'oauth_tokens_revoke',
  WebhookSubscriptionsView = 'webhook_subscriptions_view',
  WebhookSubscriptionsManage = 'webhook_subscriptions_manage',
  WebhookDeliveriesView = 'webhook_deliveries_view',
  WebhooksSend = 'webhooks_send',

  FeatureFlagsView = 'feature_flags_view',
  FeatureFlagsManage = 'feature_flags_manage',

  MaintenanceJobsRun = 'maintenance_jobs_run',

  SchedulersView = 'schedulers_view',
  SchedulersManage = 'schedulers_manage',
  SchedulerTemplatesManage = 'scheduler_templates_manage',

  RemoteConfigView = 'remote_config_view',
  RemoteConfigManage = 'remote_config_manage',
}
